// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wal-balance {
  margin-bottom: 18px;
  padding: 18px 20px;
  background: var(--grad-brand);
  border-radius: var(--radius-lg);
  color: #fff;
  box-shadow: var(--shadow-brand);
}

.wal-balance span {
  display: block;
  font-size: 0.82rem;
  opacity: 0.85;
}

.wal-balance strong {
  display: block;
  margin-top: 4px;
  font-family: var(--font-display);
  font-size: 1.6rem;
  font-weight: 800;
}

.wal-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.wal-card > svg {
  color: var(--brand);
  flex-shrink: 0;
}

.wal-card div {
  flex: 1 1;
  min-width: 0;
}

.wal-card strong {
  display: block;
  font-size: 0.94rem;
}

.wal-card span {
  font-size: 0.78rem;
  color: var(--muted2);
}

.wal-card-el {
  padding: 14px 12px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/Wallet.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;AAClB","sourcesContent":[".wal-balance {\n  margin-bottom: 18px;\n  padding: 18px 20px;\n  background: var(--grad-brand);\n  border-radius: var(--radius-lg);\n  color: #fff;\n  box-shadow: var(--shadow-brand);\n}\n\n.wal-balance span {\n  display: block;\n  font-size: 0.82rem;\n  opacity: 0.85;\n}\n\n.wal-balance strong {\n  display: block;\n  margin-top: 4px;\n  font-family: var(--font-display);\n  font-size: 1.6rem;\n  font-weight: 800;\n}\n\n.wal-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n}\n\n.wal-card > svg {\n  color: var(--brand);\n  flex-shrink: 0;\n}\n\n.wal-card div {\n  flex: 1;\n  min-width: 0;\n}\n\n.wal-card strong {\n  display: block;\n  font-size: 0.94rem;\n}\n\n.wal-card span {\n  font-size: 0.78rem;\n  color: var(--muted2);\n}\n\n.wal-card-el {\n  padding: 14px 12px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
